export interface VariantMeta {
  slug: string;
  name: string;
  tagline: string;
  emoji: string;
  gradient: [string, string];
}

export const variants: VariantMeta[] = [
  {
    slug: "v1",
    name: "Soft Pastel Dreamscape",
    tagline: "Glassmorphism, gradients, dreamy",
    emoji: "\u2728",
    gradient: ["#84D5F7", "#CBEFFF"],
  },
  {
    slug: "v2",
    name: "Retro Paper Craft",
    tagline: "Collage, paper layers, scrapbook",
    emoji: "\u2702\uFE0F",
    gradient: ["#F47781", "#F7D9DC"],
  },
  {
    slug: "v3",
    name: "Terrazzo Modern",
    tagline: "Memphis shapes, scattered chips",
    emoji: "\uD83D\uDD36",
    gradient: ["#4EB969", "#FAF7F2"],
  },
  {
    slug: "v4",
    name: "Origami Paper",
    tagline: "Geometric folds, crisp edges",
    emoji: "\uD83E\uDEAD",
    gradient: ["#F05260", "#FFF5F0"],
  },
  {
    slug: "v5",
    name: "Chalkboard Classroom",
    tagline: "Chalk texture, doodles, warmth",
    emoji: "\uD83D\uDCDD",
    gradient: ["#4EB969", "#1B3329"],
  },
  {
    slug: "v6",
    name: "Circus Ticket",
    tagline: "Vintage carnival, stripes",
    emoji: "\uD83C\uDFAA",
    gradient: ["#F47781", "#FFF8E7"],
  },
  {
    slug: "v7",
    name: "Bold Geometric Bauhaus",
    tagline: "Shapes, thick borders, modernist",
    emoji: "\u25B3",
    gradient: ["#F05260", "#CBEFFF"],
  },
  {
    slug: "v8",
    name: "Isometric Blocks",
    tagline: "3D blocks, stacked layers",
    emoji: "\uD83E\uDDF1",
    gradient: ["#F05260", "#F2F0EB"],
  },
  {
    slug: "v9",
    name: "Watercolor Bloom",
    tagline: "Soft washes, organic edges",
    emoji: "\uD83C\uDF3A",
    gradient: ["#84D5F7", "#E8F4FD"],
  },
];
